import React from "react";
import { Col, Row } from "react-bootstrap";

const campos = [
  ["tipo", "Tipo de envolvimento"],
  ["nome", "Nome completo"],
  ["nomeSocial", "Nome social"],
  ["alcunha", "Alcunha"],
  ["corRaca", "Cor ou raça"],
  ["sexo", "Sexo"],
  ["nascimento", "Data de nascimento"],
  ["orientacaoSexual", "Orientação sexual"],
  ["naturalidade", "Naturalidade"],
  ["profissao", "Profissão"],
  ["estadoCivil", "Estado civil"],
  ["escolaridade", "Escolaridade"],
  ["nomeMae", "Nome da mãe"],
  ["nomePai", "Nome do pai"],
  ["cpf", "CPF"],
  ["cnhPpd", "CNH/PPD"],
  ["endereco", "Logradouro / endereço"],
  ["numero", "Número"],
  ["complemento", "Complemento"],
  ["bairro", "Bairro"],
  ["municipio", "Município"],
  ["uf", "Estado/UF ou província"],
  ["pontoReferencia", "Ponto de referência"],
  ["telefone", "Telefone"],
  ["obs", "Observações"],
];

const EnvolvidosDetalhe = ({ envolvido }) => {
  const preenchidos = campos.filter(([campo]) => {
    const valor = envolvido[campo];
    return valor !== null && valor !== undefined && String(valor).trim() !== "";
  });
  if (envolvido.conduzido) preenchidos.push(["conduzido", "Conduzido"]);

  return (
    <section className="mb-3">
      {Array.from({ length: Math.ceil(preenchidos.length / 3) }, (_, rowIndex) => (
        <Row key={rowIndex} className="mb-1">
          {preenchidos.slice(rowIndex * 3, rowIndex * 3 + 3).map(([campo, label]) => (
            <Col key={campo} xs={12} md={4}>
              <b>{label}: </b>{campo === "conduzido" ? "Sim" : envolvido[campo]}
            </Col>
          ))}
        </Row>
      ))}
    </section>
  );
};

export default EnvolvidosDetalhe;
